module.exports = __webpack_public_path__ + "static/img/eth.9dd6048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallets/eth.png
// module id = 3qvv
// module chunks = 4